<!--<div class="align-items-center">-->
    <!--<div class="position-relative">-->
        <!--<input type="text" #container [disabled]="disabled" class="inputWithIcon col-md-12 col-lg-12" style="padding-right: 3px;"/>-->
        <!--<i class="fa fa-calendar calendaricon"></i>-->
    <!--</div>-->
<!--</div>-->

<div class="has-feedback daterange-control">
    <input type="text" #container [disabled]="disabled" class="form-control" id="daterange_1" />
    <div class="form-control-feedback"></div>
</div>
